const platform = require('platform')
const deviceLib = {
  install: function (Vue, options) {
    const main = new Vue({
      data: function () {
        return {
          isOnline: true,
          connection: {},
          platform: platform
        }
      },
      computed: {
        isApple: function () {
          if (
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) 
          ) {
            return true
          } else {
            return false
          }
        },
        isAndroid: function () {
          if (
            navigator.userAgent.match(/Android/i)
          ) {
            return true
          } else {
            return false
          }
        },
        isMobileDevice: function () {
          if (
            navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)
          ) {
            return true
          } else {
            return false
          }
        }
      },
      methods: {
        updateStatus: function (event) {
          if (typeof window.navigator.onLine === 'undefined') {
            // If the browser doesn't support connection status reports
            // assume that we are online because most apps' only react
            // when they now that the connection has been interrupted
            main.isOnline = true
          } else {
            main.isOnline = window.navigator.onLine
          }
          this.$eventHub.$emit('network-changed', main.isOnline)
          if (typeof window.navigator.connection === 'undefined') {
            main.connection = {}
          } else {
            main.connection = {
              downlink: window.navigator.connection.downlink || '',
              effectiveType: window.navigator.connection.effectiveType || ''
            }
          }
        }
      }
    })
    // Initial setup
    // Setup the listeners
    window.addEventListener('online', main.updateStatus)
    window.addEventListener('offline', main.updateStatus)
    Vue.prototype.$deviceLib = main
  }
}
export default deviceLib
